/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from 'react';
import { checkAndRouteToLoginAndUpdateStatus } from '@/utils/routes';
import styles from './index.less';

const LoginPage = ({ loginCallback = () => {}, className }) => {
  const handleJumpToLogin = useCallback(() => {
    checkAndRouteToLoginAndUpdateStatus(loginCallback);
  }, []);

  return (
    <div className={`${styles.loginPage} ${className}`}>
      <p className={styles.loginText}>登录后查看消息</p>
      <button className={styles.loginBtn} onClick={handleJumpToLogin}>
        登录
      </button>
    </div>
  );
};
export default LoginPage;
